import styled from 'styled-components';

// HISTORICO

export const HistoricoContainer = styled.div`
  .observacao {
    margin-left: 10px;
  }
`;

export const HistoricoLabel = styled.p`
  margin: 3px 10px;
  font-weight: 700;
`;

export const HistoricoRow = styled.div`
  display: flex;
  align-content: center;
  align-items: baseline;
`;

export const HistoricoDestaque = styled.p`
  margin-bottom: 10px;
  margin-top: ${props => props.marginTop};
  font-weight: 900;
  color: var(--primary-color-sefaz);
  font-size: 12pt;
  font-size: ${props => (props.fontSize ? props.fontSize : '12pt')};
`;

export const HistoricoRowEmpty = styled.div`
  display: flex;
  align-items: center;
  font-size: 10pt;
  span {
    margin-right: 10px;
    font-size: 13pt;
  }
`;

export const Label = styled.p`
  margin: 10px 10px 20px 0px;
`;

// RESUMO

export const TitleResumo = styled.p`
  font-family: 'Roboto', 'Open Sans', 'sans-serif';
  font-size: 15pt;
  color: var(--primary-color-sefaz);
  font-weight: bold;
  text-align: center;
  margin: 20px;
`;

export const ResumoStepsContainerRow = styled.div`
  display: flex;
`;

export const ResumoStepsContainerText = styled.div`
  margin-left: 5px;
`;

export const ResumoStepsCirculo = styled.div`
  height: 30px;
  width: 30px;
  border-radius: 100%;
  background-color: var(--primary-color-sefaz);
  background: linear-gradient(90deg, rgba(30, 152, 221, 1) 0%, rgba(0, 212, 255, 1) 100%);
  margin: 5px;
  transition: all 0.2s ease-in-out;

  svg {
    color: var(--bottom-color-sefaz);
    padding: 2px;
    height: 30px;
    width: 21px;
    margin: auto;
    margin-left: 4px;
    transition: all 0.2s ease-in-out;
  }

  &:hover {
    background: var(--bottom-color-sefaz);

    svg {
      color: rgba(0, 212, 255, 1);
      height: 40px;
      width: 31px;
    }
  }
`;

export const ResumoStepsTitle = styled.p`
  margin: 0px;
  font-weight: 500;
`;

export const ResumoStepsSubtitle = styled.p`
  margin: 0px;
  color: #8f8f8f;
`;

export const ResumoStepsLinha = styled.div`
  width: 5%;
  min-height: 30px;
  border-left: 2px dotted var(--primary-color-sefaz);
  margin-left: 20px;
`;

export const ResumoFinalizar = styled.div`
  margin-top: 50px;
  margin-bottom: 20px;
  font-size: 15pt;
`;
